"use client";

/**
 * The company and insurance details, closing a page as they close the
 * registration: the CMS entry tagged COMPANY_INFO_INSURANCE, rendered. No
 * heading of its own, a footnote in small print.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

type CmsAnswer = Record<string, { content?: string } | undefined>;

let cached: string | null = null;

export function CompanyInfo({ className = "" }: { className?: string }) {
  const [html, setHtml] = useState<string | null>(cached);

  useEffect(() => {
    if (cached !== null) {
      return;
    }
    let cancelled = false;
    api.get<CmsAnswer>("/public-api/cms?tags=COMPANY_INFO_INSURANCE", { silent: true }).then((cms) => {
      const content = cms?.COMPANY_INFO_INSURANCE?.content || "";
      cached = content;
      if (!cancelled) {
        setHtml(content);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!html) {
    return null;
  }
  return <div className={`rich-text text-[12px] leading-relaxed text-ink-mute [&_p]:mb-1 ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
